"use client";

import { useSidebarToggle } from "@/store/common";
import { Facebook, Twitter, Instagram, Linkedin, Youtube } from "lucide-react";

export default function Footer() {
  const facebookLink = process.env.NEXT_PUBLIC_FACEBOOK || "#";
  const twitterLink = process.env.NEXT_PUBLIC_TWITTER || "#";
  const instagramLink = process.env.NEXT_PUBLIC_INSTAGRAM || "#";
  const linkedinLink = process.env.NEXT_PUBLIC_LINKEDIN || "#";
  const youtubeLink = process.env.NEXT_PUBLIC_YOUTUBE || "#";
  const commonLink = "https://bookingcabs.com";
  
  const {SidebarData} = useSidebarToggle()

  return (
    <footer className="bg-white shadow-md py-2 fixed bottom-0 left-0 z-30 w-full">
      <div className="max-w-8xl mx-auto px-4 flex items-center justify-between">
        {/* Left: Copyright */}
        <p className={`text-sm text-gray-700 ${!SidebarData.isCollapsed ? "sm:pl-[250px]" : "pl-[50px]"}`}>
          &copy; {new Date().getFullYear()}{" "}
          <a
            href={commonLink}
            target="_blank"
            rel="noopener noreferrer"
            className={`hover:underline `}
          >
            Bookingcabs.com
          </a>{" "}
          | All rights reserved.
        </p>

        {/* Right: Social Media Links */}
        <div className="flex space-x-4">
          {facebookLink && (
            <a
              href={facebookLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <Facebook className="w-5 h-5 text-gray-600 hover:text-blue-600" />
            </a>
          )}
          {twitterLink && (
            <a
              href={twitterLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <Twitter className="w-5 h-5 text-gray-600 hover:text-sky-500" />
            </a>
          )}
          {instagramLink && (
            <a
              href={instagramLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5 text-gray-600 hover:text-pink-500" />
            </a>
          )}
          {linkedinLink && (
            <a
              href={linkedinLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-5 h-5 text-gray-600 hover:text-blue-700" />
            </a>
          )}
          {youtubeLink && (
            <a
              href={youtubeLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <Youtube className="w-5 h-5 text-gray-600 hover:text-red-600" />
            </a>
          )}
        </div>
      </div>
    </footer>
  );
}
